import React, { useEffect } from "react";
import "./Banner.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { useDispatch, useSelector } from "react-redux";
import { EffectFade, Autoplay, Pagination } from "swiper/modules";
import { getHomeBanner } from "../../../features/home/homeSlice";
import { getAllCategories } from "../../../features/master/masterSlice";
import { Link, useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";
const SECRET_KEY = "my_secret_key_123";
function Banner({ handleFilterChange, categories, banners }) {
  const handleClick = async (filter, value) => {
    await handleFilterChange(filter, value);
  };
  const navigate = useNavigate();

  // Function to encrypt gender object
  const encryptData = (data) => {
    return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
  };
  const handleCategory = (gender) => {
    console.log(gender, "gender gender gender");

    const token = encryptData(gender);
    navigate(`/all-products?category=${encodeURIComponent(token)}`);
  };
  return (
    <section className="home_banner">
      <div className="container-xl">
        <div className="bannersec">
          <div className="flexbansec">
            <div className="subcatdiv">
              <div className="sidediv">
                {categories && categories.length > 0 ? (
                  categories.slice(0, 2).map((category) => (
                    // <Link
                    //   className="link_text"
                    //   // to={"/all-products"}
                    //   onClick={() =>
                    //     handleCategory({
                    //       id: category?.id,
                    //       name: category?.name,
                    //     })
                    //   }

                    //   // onClick={() => {
                    //   //   handleClick("category", {
                    //   //     id: category?.id,
                    //   //     name: category?.name,
                    //   //   });
                    //   // }}
                    // >
                    <div
                      className="imgdivv"
                      key={category.id}
                      onClick={() =>
                        handleCategory({
                          id: category?.id,
                          name: category?.name,
                        })
                      }
                    >
                      <img
                        className="subgogle"
                        src={process.env.REACT_APP_IMAGE_URL + category.image}
                        alt={category.name || "Category"}
                        // onError={(e) => {
                        //   e.target.src =
                        //     process.env.PUBLIC_URL +
                        //     "/assets/images/home/banner/fallback.png";
                        // }}
                      />
                      <p className="gogname">{category.name}</p>
                    </div>
                    // </Link>
                  ))
                ) : (
                  <div className="no-data">No Categories</div>
                )}
              </div>
            </div>

            <div className="middiv">
              <div className="swipersec">
                <Swiper
                  spaceBetween={30}
                  centeredSlides={true}
                  loop={banners && banners.length > 1}
                  autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                  }}
                  pagination={{
                    clickable: true,
                  }}
                  navigation={false}
                  modules={[EffectFade, Autoplay, Pagination]}
                  className="mySwiper"
                >
                  {banners && banners?.length > 0 ? (
                    banners?.map((banner, index) => (
                      <SwiperSlide key={banner.id || index}>
                        <div className="sliderdiv">
                          <img
                            className="slideimg"
                            src={process.env.REACT_APP_IMAGE_URL + banner.image}
                            alt={banner.name || `Slide ${index + 1}`}
                            // onError={(e) => {
                            //   e.target.src =
                            //     process.env.PUBLIC_URL +
                            //     "/assets/images/home/banner/fallback.png";
                            // }}
                          />
                        </div>
                      </SwiperSlide>
                    ))
                  ) : (
                    <SwiperSlide>
                      <div className="sliderdiv">
                        <img
                          className="slideimg"
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/images/home/banner/fallback.png"
                          }
                          alt="No banners available"
                        />
                      </div>
                    </SwiperSlide>
                  )}
                </Swiper>
              </div>
            </div>

            <div className="subcatdiv">
              <div className="sidediv">
                {categories && categories.length > 2 ? (
                  categories.slice(2, 4).map((category) => (
                    // <Link
                    //   className="link_text"
                    //   // to={"/all-products"}
                    //  onClick={() =>
                    //     handleCategory({
                    //       id: category?.id,
                    //       name: category?.name,
                    //     })
                    //   }
                    //   // onClick={() => {
                    //   //   handleClick("category", {
                    //   //     id: category?.id,
                    //   //     name: category?.name,
                    //   //   });
                    //   // }}
                    // >
                    <div
                      className="imgdivv"
                      key={category.id}
                      onClick={() =>
                        handleCategory({
                          id: category?.id,
                          name: category?.name,
                        })
                      }
                    >
                      <img
                        className="subgogle"
                        src={process.env.REACT_APP_IMAGE_URL + category.image}
                        // alt={category.name || "Category"}
                        // onError={(e) => {
                        //   e.target.src =
                        //     process.env.PUBLIC_URL +
                        //     "/assets/images/home/banner/fallback.png";
                        // }}
                      />
                      <p className="gogname">{category.name}</p>
                    </div>
                    // </Link>
                  ))
                ) : (
                  <div className="no-data">No Categories</div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Banner;
